import Vue from 'vue'
import grid from './grid/index.vue'
import edit from './edit/index.vue'
import select from './select.vue'

Vue.component('app-empresa-grid', grid)
Vue.component('app-empresa-edit', edit)
Vue.component('app-empresa-select', select)
